/*
 * Sommaire automatique d'article — Be Healthy
 * --------------------------------------------
 * Scanne les <h2> de .article-template__content, leur assigne un id slug,
 * génère la liste numérotée du sommaire et met en surbrillance la section
 * actuellement visible via IntersectionObserver.
 *
 * Inspiration : SOVA Care (numérotation 01. 02. 03.)
 * Numérotation gérée en CSS (counter-reset / counter-increment).
 */

(function () {
  'use strict';

  function slugify(text) {
    return String(text)
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '') // retire les accents
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .substring(0, 80) || 'section';
  }

  function ensureUniqueId(baseId, usedIds) {
    if (!usedIds.has(baseId)) {
      usedIds.add(baseId);
      return baseId;
    }
    var i = 2;
    while (usedIds.has(baseId + '-' + i)) i++;
    var unique = baseId + '-' + i;
    usedIds.add(unique);
    return unique;
  }

  function buildToc() {
    var toc = document.querySelector('[data-blog-toc]');
    var list = document.querySelector('[data-blog-toc-list]');
    var content = document.querySelector('.article-template__content');
    if (!toc || !list || !content) return;

    var headings = content.querySelectorAll('h2');
    if (headings.length < 2) {
      toc.setAttribute('hidden', '');
      return;
    }

    var usedIds = new Set();
    document.querySelectorAll('[id]').forEach(function (el) { usedIds.add(el.id); });

    var fragment = document.createDocumentFragment();
    var linkMap = new Map(); // heading id -> <a>

    headings.forEach(function (h2) {
      var existingId = h2.getAttribute('id');
      var id;
      if (existingId) {
        id = existingId;
      } else {
        var base = slugify(h2.textContent || '');
        id = ensureUniqueId(base, usedIds);
        h2.setAttribute('id', id);
      }

      var li = document.createElement('li');
      li.className = 'blog-toc__item';

      var a = document.createElement('a');
      a.className = 'blog-toc__link';
      a.href = '#' + id;
      a.textContent = (h2.textContent || '').trim();

      li.appendChild(a);
      fragment.appendChild(li);
      linkMap.set(id, a);
    });

    list.innerHTML = '';
    list.appendChild(fragment);
    toc.removeAttribute('hidden');

    // Highlight de la section active via IntersectionObserver
    if ('IntersectionObserver' in window) {
      var active = null;
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var id = entry.target.getAttribute('id');
          if (!id) return;
          var link = linkMap.get(id);
          if (!link) return;
          if (entry.isIntersecting) {
            if (active && active !== link) active.classList.remove('is-active');
            link.classList.add('is-active');
            active = link;
          }
        });
      }, {
        rootMargin: '-20% 0px -70% 0px',
        threshold: 0
      });

      headings.forEach(function (h2) { observer.observe(h2); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildToc);
  } else {
    buildToc();
  }
})();
